import { getCurrentLanguage } from "utils/src/getCurrentLanguage";
import { apiClient } from "../../../../apps/crossword-maker/src/shared/apiClient";

export type TDeleteWordCategory = (wordCategoryId: string) => Promise<void>;

export const deleteWordCategory: TDeleteWordCategory = async (wordCategoryId) => {
	const language = getCurrentLanguage();
	await apiClient().delete(`/rest/${language}/crossword-book/word-category/${wordCategoryId}`);
};
